<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let {
    sectionLabel = "",
    headline = "",
    members = [] as Array<{
      initials: string;
      name: string;
      role: string;
      description: string;
      skills: string[];
    }>
  } = $props();
</script>

<section>
  <div class="container">
    {#if sectionLabel}
      <div class="section-divider fade-up" use:observe>
        <span class="section-label">{sectionLabel}</span>
        <h2>{headline}</h2>
      </div>
    {/if}
    <div class="team-grid stagger" use:observe>
      {#each members as member}
        <div class="card team-card">
          <div class="team-avatar" style="margin:0 auto 12px">
            {member.initials}
          </div>
          <h3>{member.name}</h3>
          <p style="font-size:0.875rem;color:var(--accent);font-weight:600;margin-bottom:8px">{member.role}</p>
          <p style="font-size:0.85rem">{member.description}</p>
          {#if member.skills.length}
            <div class="tags" style="margin-top:12px;justify-content:center">
              {#each member.skills as skill}
                <span class="tag">{skill}</span>
              {/each}
            </div>
          {/if}
        </div>
      {/each}
    </div>
  </div>
</section>
